import React from 'react';
import { IconButton, Tooltip } from '@material-ui/core';

const RMSIconButton = ({
  icon,
  tooltip,
  label,
  onClick,
  disabled = false,
  color = 'default',
  ...rest
}) => {
  const button = (
    <IconButton color={color} onClick={onClick} disabled={disabled} aria-label={label} {...rest}>
      {icon}
    </IconButton>
  );

  return tooltip || label ? (
    <Tooltip title={tooltip || label} placement="top">
      <span>{button}</span>
    </Tooltip>
  ) : (
    button
  );
};

export default RMSIconButton;

/**
 * RMSIconButton Component
 *
 * Available Props:
 * icon       : ReactNode
 * label      : string
 * tooltip    : string
 * color      : 'default' | 'primary' | 'secondary' | 'inherit'
 * disabled   : boolean
 * onClick    : function
 *
 * Supports all Material UI <IconButton /> props via ...rest.
 *
 * Example:
 *
 * <RMSIconButton
 *   icon={<CloseIcon />}
 *   tooltip="Close"
 *   color="secondary"
 *   onClick={handleClose}
 * />
 *
 * <RMSIconButton
 *   icon={<EditIcon />}
 *   tooltip="Edit"
 *   color="primary"
 *   disabled={isReadOnly}
 *   onClick={handleEdit}
 * />
 */
